var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BulkActionMenu',{attrs:{"actions":_vm.actions,"disabled":_vm.selectedItems && _vm.selectedItems.length !== 2},scopedSlots:_vm._u([{key:"compare",fn:function(ref){
var hide = ref.hide;
return [_c('Compare',{attrs:{"selected-items":_vm.selectedItems},on:{"trigger":hide}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }